import { Point } from 'pixi.js';
import { WinCriteriaTypeMap } from '../../../Constants/WinCriteria';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import Text from '../../../Prototype/Text';
import Element from '../../../Prototype/UI/Element';
import ITask from '../../../Utility/Task/ITask';
import { delay } from '../../../Utility/Task/TaskQueue';
import { StartAnimation } from '../../Animation/AnimationHelper';
import CardSystem from '../../Card/CardSystem';
import Interactable from '../../../Component/Interactable';
import Overlay from '../../../Prototype/UI/Overlay';
import { CharacterPoses, ThemeSettings } from 'Constants/Theme';

export default class GoalMenuTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        let clicked: boolean = false;
        const goals = system.store.getState().levelState.winCriteria;

        const { textKey, texture } = WinCriteriaTypeMap[goals[0].type];

        const overlay = GameObject.Instantiate(Overlay);

        const container = GameObject.Instantiate(Element, {
            name: 'container',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0, 0],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            relativePosition: new Point(0.5, 0.5),
        });
        const barXScale: number = 1.2;
        const bar = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'bar',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [barXScale, 1],
                constrains: {
                    heightMin: 130,
                    heightMax: 130,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'user_part',
                        offset: [0, 0, 0, 0],
                    },
                },
            ],
            visible: false,
        });

        const title = GameObject.Instantiate(Text, {
            text: Game.locale.getText(textKey),
            relativePosition: new Point(0.5, 0.08),
            scale: new Point(1 / barXScale, 1),
            anchor: new Point(0.5, 0.5),
            style: Game.style.getStyle('goal_bar.title'),
            bounds: new Point(550, 300),
        });

        const foxy = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'foxy',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.35],
                scale: [1 / barXScale, 1],
                offsets: ThemeSettings.CHARACTER_GOLD_FTUX_OFFSETS,
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: ThemeSettings.CHARACTER_CACHE_KEYS[CharacterPoses.Idle],
                    },
                },
            ],
        });

        const iconContainer = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'icon_container',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [-400, 0, -400, 0],
                scale: [1 / barXScale, 1],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'blank',
                    },
                },
            ],
        });
        const goldCard1 = GameObject.Instantiate(Element, {
            name: 'gold_card_1',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [100, 0, 100, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'gold_card_1',
                    },
                },
            ],
        });
        const goldCard2 = GameObject.Instantiate(Element, {
            name: 'gold_card_1',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [-100, 0, -100, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'gold_card_2',
                    },
                },
            ],
        });
        const goldCard3 = GameObject.Instantiate(Element, {
            name: 'gold_card_1',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, -100, 0, -100],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'gold_card_3',
                    },
                },
            ],
        });
        const goldCard4 = GameObject.Instantiate(Element, {
            name: 'gold_card_1',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 100, 0, 100],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'gold_card_4',
                    },
                },
            ],
        });

        const tutorialText = GameObject.Instantiate(Text, {
            text: Game.locale.getText('TutorialGold'),
            style: {
                ...Game.style.getStyle('ftux.text'),
                fontSize: 42,
            },
            bounds: new Point(500, 480),
            anchor: new Point(0.5, 0.5),
            position: new Point(0, 150),
        });

        iconContainer.addChild(goldCard1);
        iconContainer.addChild(goldCard2);
        iconContainer.addChild(goldCard3);
        iconContainer.addChild(goldCard4);
        bar.addChild(title);
        bar.addChild(foxy);
        bar.addChild(iconContainer);
        title.addChild(tutorialText);
        container.addChild(bar);

        system.scene.addGameObject(overlay);
        system.scene.addGameObject(container);

        StartAnimation(overlay, 'OverlayFadeIn');
        StartAnimation(bar, 'GoalBarPopIn');

        // TODO: Add audio
        /* PlaySound(AUDIO_UI_POPUP_OPEN_DEFAULT); */
        yield* delay(100);
        const overlayInteractable = overlay.getComponent(Interactable);
        overlayInteractable.enabled = true;
        overlay.once(GameObjectEvent.SELECTED, () => {
            clicked = true;
            overlayInteractable.enabled = false;
        });
        while (!clicked) {
            yield;
        }

        StartAnimation(overlay, 'OverlayFadeOut');
        StartAnimation(bar, 'GoalBarPopOut');

        // TODO: Add audio
        /* PlaySound(AUDIO_UI_POPUP_CLOSE_DEFAULT); */
    }
}
